<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section" style="padding-bottom: 0px !important;">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Create Wallet</h2>
              <h2 class="listing-page-desc">Fill Details</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>
    </div>

<!-- ///////////////////////////////////////////////// -->
<div class="container-fluid ib-acquisition-bg">
        <div class="container ib-p-0">
          <form @submit.prevent="" id="bootstrapForm">
            <div class="container multistep-box box-custom-padding">
              <!-- flower for box -->
              <img class="img-fluid in-flower-for-box" alt="icon" :src="require('@/assets/images/flower-for-box.svg')" />
              <!-- flower for box -->
              <!-- <div class="row pt-4 wow animate__animated animate__fadeInUp">
                <div class="col-md-6">
                  <div>
                    <div class="jbl-field-sign">
                    <label class="jbl-label-sign">Account Title</label>
                    <input type="text" class="ib-login-input" name="account_title" v-model="account_title" placeholder="Account Title">
                  </div>

                  <div v-if="errors.filter(x => x.field == 'account_title').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'account_title')[0].message}}</small>
                    </div>
                  </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div>
                    <div class="jbl-field-sign">
                    <label class="jbl-label-sign">Bank Name</label>
                    <input type="text" class="ib-login-input" name="bank_name" v-model="bank_name" placeholder="Bank Name">
                  </div>

                  <div v-if="errors.filter(x => x.field == 'bank_name').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'bank_name')[0].message}}</small>
                    </div>
                  </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="row pt-4 wow animate__animated animate__fadeInUp">
                <div class="col-md-6">
                  <div>
                    <div class="jbl-field-sign">
                    <label class="jbl-label-sign">Bank IMD</label>
                    <input type="text" class="ib-login-input" name="bank_imd" v-model="bank_imd" placeholder="123456">
                  </div>

                  <div v-if="errors.filter(x => x.field == 'bank_imd').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'bank_imd')[0].message}}</small>
                    </div>
                  </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div>
                    <div class="jbl-field-sign">
                    <label class="jbl-label-sign">Branch Name</label>
                    <input type="text" class="ib-login-input" name="branch_name" v-model="branch_name" placeholder="Branch Name">
                  </div>

                  <div v-if="errors.filter(x => x.field == 'branch_name').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'branch_name')[0].message}}</small>
                    </div>
                  </div>
                  </div>
                </div>
              </div> -->
              <div class="row pt-4 wow animate__animated animate__fadeInUp">
                <div class="col-md-6">
                  <div>
                    <div class="jbl-field-sign">
                    <label class="jbl-label-sign">CNIC</label>
                    <input type="text" class="ib-login-input" name="cnic" v-model="cnic" placeholder="35201-1234567-8" v-mask="'#####-#######-#'">
                  </div>

                  <div v-if="errors.filter(x => x.field == 'cnic').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'cnic')[0].message}}</small>
                    </div>
                  </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="jbl-field-sign">
                    <label class="jbl-label-sign">CNIC Issuance Date</label>
<!--                    <input type="text" class="ib-login-input" name="cnic_issuance_date" v-model="cnic_issuance_date" placeholder="CNIC Issuance Date" maxlength="25">-->
                       <div class="jbl-field">
                        <datepicker initial-view="year" class="jbl-dynamic-input" name="cnic_issue_date" v-model="cnic_issue_date" :max="issueDate" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                      </div>
                  </div>

                  <div v-if="errors.filter(x => x.field == 'cnic_issue_date').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'cnic_issue_date')[0].message}}</small>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row pt-4 wow animate__animated animate__fadeInUp">
                <div class="col-md-6">
                  <div class="jbl-field-sign">
                    <label class="jbl-label-sign">Mobile</label>
                    <input v-mask="'+92##########'" type="text" class="ib-login-input" v-model="mobile_no" @input="validateMobileNo($event)" placeholder="+923001234567"/>
                  </div>

                  <div v-if="errors.filter(x => x.field == 'mobile_no').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'mobile_no')[0].message}}</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="jbl-field-sign">
                    <label class="jbl-label-sign">Mobile Network</label>
                    <select style="width: 100% !important;" class="floating-select" v-model="mobile_network">
                      <option value="">-- Please select --</option>
                      <option value="Jazz">Jazz</option>
                      <option value="Ufone">Ufone</option>
                      <option value="Zong">Zong</option>
                      <option value="Telenor">Telenor</option>
                    </select>
                  </div>

                  <div v-if="errors.filter(x => x.field == 'mobile_network').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'mobile_network')[0].message}}</small>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="row pt-4 wow animate__animated animate__fadeInUp">
                <div class="col-md-6">
                  <div>
                    <div class="jbl-field-sign">
                    <label class="jbl-label-sign">IBAN</label>
                    <input type="text" class="ib-login-input" name="iban" v-model="iban" placeholder="PK70 BANK 0000 1234 5678 9000" v-mask="'#### #### #### #### #### ####'">
                  </div>

                  <div v-if="errors.filter(x => x.field == 'iban').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'iban')[0].message}}</small>
                    </div>
                  </div>
                  </div>
                </div>
              </div> -->

              <div class="ib-action-btns">
                <button type="submit" class="ib-btn-primary ib-btn-width mr-3" @click="CreateWallet()">Create wallet</button>
                <router-link :to="{ name: 'Home' }" class="ib-btn-outline ib-btn-width" style="display:inline-block;">Cancel</router-link>
              </div>
<!--              <div id="OtpAcquisition" class="modal" role="dialog" style="backdrop-filter: contrast(0.5);">-->
<!--                <div class="modal-dialog modal-lg modal-dialog-scrollable">-->
<!--                  &lt;!&ndash; Modal content&ndash;&gt;-->
<!--                  <div class="modal-content ib-login-modal">-->
<!--                    <div class="modal-header ib-modal-header">-->
<!--                  <span class="ib-m-close ib-x-m-icon" @click="closeOtpModal()">-->
<!--                    &lt;!&ndash; &times; &ndash;&gt;-->
<!--                    <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />-->
<!--                  </span>-->
<!--                    </div>-->
<!--                    <div class="modal-body login-modal-body" style="min-height: 500px;">-->
<!--                      <otp :user="user" v-if="renderOtpModal"/>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="modal-body login-modal-body" style="min-height: 500px;">-->
<!--                <verifymobile :mobile="otpMobile" :quotationId="quotationDetails.customer_quotation_id" v-if="renderVerifyMobileModal"/>-->
<!--              </div>-->
              <div id="VerifyMobileModal" class="modal" role="dialog" style="backdrop-filter: contrast(0.5);">
                <div class="modal-dialog modal-lg modal-dialog-scrollable">
                  <!-- Modal content-->
                  <div class="modal-content ib-login-modal">
                    <div class="modal-header ib-modal-header">
                  <span class="ib-m-close ib-x-m-icon" @click="closeVerifyMobileModal()">
                    <!-- &times; -->
                    <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                  </span>
                    </div>
                    <div class="modal-body login-modal-body" style="min-height: 500px;">
                      <verifymobile @mobileOTP="getMobileOTP" @mobileModal="getMobileModal" :renderVerifyMobileModal="renderVerifyMobileModal" :create_wallet="create_wallet"  @customer_quotation_id="getCustomerQuotationId" v-if="renderVerifyMobileModal"/>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </form>
        </div>
      </div>
<!-- ///////////////////////////////////////////////// -->
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import MaskedInput from "vue-masked-input";
  import axios from 'axios';
  import { mask } from 'vue-the-mask';
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment';
  // import otp from '@/components/Auth/OtpVerificationAcquisition';
  import verifymobile from '@/components/Auth/VerifyMobile';

  export default {
    name: "CreateWallet",
    data () {
      return {
        showLoader: false,
        errors : [],
        cnic: '',
        cnic_issue_date: '',
        renderOtpModal: false,
        renderVerifyMobileModal: false,
        otpMobile: '',
        user:{},
        otp:'',
        quotationDetais:{},
        mobileNumberVerified: false,
        create_wallet:'create_wallet',
        // mobile_no:'',
        // mobile_network:'',
        // bank_imd:'',
        // account_title:'',
        // bank_name:'',
        // branch_name:'',
        // iban:'',
      };
    },
    components: {
      loading,
      Datepicker,
      // otp,
      verifymobile,
    },
  directives: { mask },
    created () {
      const self = this;
      self.user = self.$store.getters.getUser;
      self.quotationDetais = self.$store.getters.getQuotationDetails;

    },
  computed: {
    issueDate () {
      return moment().format('YYYY-MM-DD');
    }
  },
    methods:{
      getMobileModal(value){
        this.renderVerifyMobileModal = value;
        document.getElementById('VerifyMobileModal').style.display = 'none';

      },
      getMobileOTP(value){
        this.otp = value;
        this.verifyOtp();
      },
      showOtpModal() {
        const self = this;
        self.renderVerifyMobileModal = true;
        document.getElementById('VerifyMobileModal').style.display = 'block';
      },
      closeVerifyMobileModal() {
        const self = this;
        self.renderVerifyMobileModal = false;
        self.otpMobile = '';
        document.getElementById('VerifyMobileModal').style.display = 'none';
      },
      async CreateWallet() {
      const self = this;
      self.errors = [];
      self.showLoader = true;
      if (self.cnic == '') {
        self.errors.push({
          field: 'cnic',
          message: 'CNIC Required'
        });
      }
      // console.log(self.cnic.length);
      if (self.cnic.length < 15) {
        self.errors.push({
          field: 'cnic',
          message: 'Invalid CNIC'
        });
      }
      if (self.cnic_issue_date == '') {
        self.errors.push({
          field: 'cnic_issue_date',
          message: 'CNIC Issuance Date Required'
        });
      }
      let todayDate = moment().startOf('day');
      console.log('today_date',todayDate);
      let selectedDate = moment(self.cnic_issue_date, "YYYY-MM-DD");
      console.log('selected Data',selectedDate);
        if (selectedDate > todayDate) {
          self.errors.push({
            field: 'cnic_issue_date',
            message: 'Cnic issue date must be less than or equal to ' + moment(todayDate).format('DD-MMM-YYYY')
          });
        }
      self.showLoader = false;
      if(self.errors.length > 0){
        return false;
      }

       var formData = new FormData();
      formData.append('cnic', self.cnic);
      formData.append('cnic_issuance_date', self.cnic_issue_date);
        this.$swal.fire({
          text: "Would You Like To Create Wallet",
          icon: '',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'No',
          confirmButtonColor: '#f77c94',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {
            if(!self.mobileNumberVerified) {
              self.showOtpModal();
              return false;
            }
          }
        });
        // self.otpMobile = self.user.mobile_no;
        // if(self.customer_quotation_id !=undefined && self.otpMobile !='') {
        //

        //
        //   await axios.post('customer/quotation/send_otp', formData).then(function (resp) {
        //     if (resp.data.code == 200) {
        //       $toast.success(resp.data.message, {position: 'top-right'});
        //       self.renderVerifyMobileModal = true;
        //       document.getElementById('VerifyMobileModal').style.display = 'block';
        //     } else {
        //       self.showLoader = false;
        //       $toast.error(resp.data.message, {position: 'top-right'});
        //       return false;
        //     }
        //   }).catch(function (error) {
        //     self.showLoader = false;
        //     if (error.response) {
        //       error.response.data.errors.forEach(element => {
        //         $toast.error(element.message, {position: 'top-right'});
        //       });
        //     } else {
        //       $toast.error(error.data.message, {position: 'top-right'});
        //     }
        //   });
        // }
      await axios.post('customer/create_wallet',formData).then(async function (resp) {
        if (resp.data.code == 200) {
          self.showLoader = false;
          self.renderVerifyMobileModal = true;
          document.getElementById('VerifyMobileModal').style.display = 'block';
          setTimeout($toast.success('Wallet created Successfully!', { position: 'top-right' }),2000);
          // self.$router.push({ name: 'ViewWallet' });
        } else {
          self.showLoader = false;
          $toast.error('Wallet not created: '+resp.data.message, {position: 'top-right'});
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if (error.response) {
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, {position: 'top-right'});
          });
        } else {
          $toast.error(error.data.message, {position: 'top-right'});
        }
      });

    },
      async verifyOtp(){
       const self = this;
        if(self.otp !=''){
          var formData = new FormData();
          formData.append('otpPin', '1234');
          await axios.post('customer/verify_wallet', formData).then(function (resp) {
            if (resp.data.code == 200) {
              $toast.success(resp.data.message, {position: 'top-right'});
              self.$router.push({ name: 'ViewWallet' });
            } else {
              self.showLoader = false;
              $toast.error(resp.data.message, {position: 'top-right'});
              return false;
            }
          }).catch(function (error) {
            self.showLoader = false;
            if (error.response) {
              error.response.data.errors.forEach(element => {
                $toast.error(element.message, {position: 'top-right'});
              });
            } else {
              $toast.error(error.data.message, {position: 'top-right'});
            }
          });
        }

      },

    }
  };
</script>
<style scoped>
@media (max-width: 550px){
  .multistep-box {
    overflow-x: visible !important;
    overflow-y: visible !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Wallet/CreateWallet.vue